import axiosInstance from './axiosInstance';

const backendUrl = process.env.REACT_APP_LOG_SERVER_BACKEND_URL || 'https://unified.buildings.dev-dttsynergy.com/api';//'http://localhost:5000';

const logToServer = (level, message) => {
    // const response = axiosInstance("POST", "/api/log", { level, message }, 'application/json', backendUrl);
    // return response.data;

    // const { data: info } = useFetch("/log", "saveLog", { level, message }, null, "POST", backendUrl);
    // Log para verificar o URL
    // axios.post(`${backendUrl}/log`, { level, message })
    //     .then(response => {
    //         console.log('Log enviado com sucesso:', response.data);
    //     })
    //     .catch(error => {
    //         console.error('Erro ao enviar log:', error.message);
    //     });
};

const logger = {
    info: (message) => {
        console.log(`INFO: ${message}`);
        logToServer('info', message);
    },
    warn: (message) => {
        console.warn(`WARN: ${message}`);
        logToServer('warn', message);
    },
    error: (message) => {
        console.error(`ERROR: ${message}`);
        logToServer('error', message);
    },
};

export default logger;